import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { DataClassPathSerializer1pr4zwqha0dv8 as DataClassPathSerializer } from '../serialization/DataClassPathSerializer.mjs';
import {
  LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { ConditionSerializer21tf3x2n3amih as ConditionSerializer } from './ConditionSerialization.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Always_getInstancecs10mhg5aot2 as Always_getInstance } from './Condition.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { SortPartSerializer1fx0t5bmnpc8h as SortPartSerializer } from './SortPartSerializer.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.QueryPartial', null, 5);
        tmp0_serialDesc.c1b('fields', false);
        tmp0_serialDesc.c1b('condition', true);
        tmp0_serialDesc.c1b('orderBy', true);
        tmp0_serialDesc.c1b('skip', true);
        tmp0_serialDesc.c1b('limit', true);
        this.x3k_1 = tmp0_serialDesc;
      }
      d2j(typeSerial0) {
        return $serializer().b4a(typeSerial0);
      }
      h1c(typeParamsSerializers) {
        return this.d2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      static c4a() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.QueryPartial', $this, 5);
        tmp0_serialDesc.c1b('fields', false);
        tmp0_serialDesc.c1b('condition', true);
        tmp0_serialDesc.c1b('orderBy', true);
        tmp0_serialDesc.c1b('skip', true);
        tmp0_serialDesc.c1b('limit', true);
        $this.z49_1 = tmp0_serialDesc;
        return $this;
      }
      d4a(encoder, value) {
        var tmp0_desc = this.z49_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, new (LinkedHashSetSerializer())(new (DataClassPathSerializer())(this.a4a_1)), value.e4a_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !value.f4a_1.equals(Always_getInstance())) {
          tmp1_output.c15(tmp0_desc, 1, new (ConditionSerializer())(this.a4a_1), value.f4a_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 2)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.g4a_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 2, new (ArrayListSerializer())(new (SortPartSerializer())(this.a4a_1)), value.g4a_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.h4a_1 === 0)) {
          tmp1_output.v14(tmp0_desc, 3, value.h4a_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.i4a_1 === 100)) {
          tmp1_output.v14(tmp0_desc, 4, value.i4a_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.d4a(encoder, value instanceof QueryPartial() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.z49_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = 0;
        var tmp8_local4 = 0;
        var tmp9_input = decoder.l13(tmp0_desc);
        if (tmp9_input.a14()) {
          tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, new (LinkedHashSetSerializer())(new (DataClassPathSerializer())(this.a4a_1)), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.x13(tmp0_desc, 1, new (ConditionSerializer())(this.a4a_1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.x13(tmp0_desc, 2, new (ArrayListSerializer())(new (SortPartSerializer())(this.a4a_1)), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.q13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.q13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, new (LinkedHashSetSerializer())(new (DataClassPathSerializer())(this.a4a_1)), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.x13(tmp0_desc, 1, new (ConditionSerializer())(this.a4a_1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.x13(tmp0_desc, 2, new (ArrayListSerializer())(new (SortPartSerializer())(this.a4a_1)), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.q13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.q13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp9_input.m13(tmp0_desc);
        return QueryPartial().j4a(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.z49_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (LinkedHashSetSerializer())(new (DataClassPathSerializer())(this.a4a_1)), new (ConditionSerializer())(this.a4a_1), new (ArrayListSerializer())(new (SortPartSerializer())(this.a4a_1)), IntSerializer_getInstance(), IntSerializer_getInstance()];
      }
      u1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.a4a_1];
      }
      static b4a(typeSerial0) {
        var $this = this.c4a();
        $this.a4a_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var QueryPartialClass;
function QueryPartial() {
  if (QueryPartialClass === VOID) {
    class $ {
      toString() {
        return 'QueryPartial(fields=' + toString(this.e4a_1) + ', condition=' + toString(this.f4a_1) + ', orderBy=' + toString(this.g4a_1) + ', skip=' + this.h4a_1 + ', limit=' + this.i4a_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.e4a_1);
        result = imul(result, 31) + this.f4a_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.g4a_1) | 0;
        result = imul(result, 31) + this.h4a_1 | 0;
        result = imul(result, 31) + this.i4a_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof QueryPartial()))
          return false;
        if (!equals(this.e4a_1, other.e4a_1))
          return false;
        if (!this.f4a_1.equals(other.f4a_1))
          return false;
        if (!equals(this.g4a_1, other.g4a_1))
          return false;
        if (!(this.h4a_1 === other.h4a_1))
          return false;
        if (!(this.i4a_1 === other.i4a_1))
          return false;
        return true;
      }
      static j4a(seen0, fields, condition, orderBy, skip, limit, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, Companion_getInstance().x3k_1);
        }
        var $this = createThis(this);
        $this.e4a_1 = fields;
        if (0 === (seen0 & 2))
          $this.f4a_1 = Always_getInstance();
        else
          $this.f4a_1 = condition;
        if (0 === (seen0 & 4)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.g4a_1 = emptyList();
        } else
          $this.g4a_1 = orderBy;
        if (0 === (seen0 & 8))
          $this.h4a_1 = 0;
        else
          $this.h4a_1 = skip;
        if (0 === (seen0 & 16))
          $this.i4a_1 = 100;
        else
          $this.i4a_1 = limit;
        return $this;
      }
    }
    initMetadataForClass($, 'QueryPartial', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    QueryPartialClass = $;
  }
  return QueryPartialClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance2ox6dwbhzwjsb,
};
//endregion

//# sourceMappingURL=QueryPartial.mjs.map
